import React from 'react';
import { configure, reaction } from 'mobx';
import WebApi from './WebApi';

//import { RootStoreInterface } from 'interfaces';
import { decorate, observable, action, runInAction } from 'mobx';
import UsersStore from './Users/stores/UsersStore';
import LimitsStore from './Limits/stores/LimitsStore';
import AuthStore from './Auth/stores/AuthStore';
//import InfoStore from './Auth/stores/InfoStore';
import SpecificationsStore from './Specifications/stores/SpecificationsStore';
import WebSocketStore from './WebSockets/stores/WebSocketsStore';
import MailerStore from './Mailer/stores/MailerStore';


/*
import PartnerStore from './PartnerStore/index';
import LegacyRoutesStore from './LegacyRoutesStore';
import HomePageStore from './HomePageStore';
import AuthStore from './AuthStore';
*/

configure({ enforceActions: 'observed' });



export class RootStore implements RootStoreInterface {
    apiClient = undefined;

    usersStore = undefined;
    limitsStore = undefined;

    modulesStore = {};

    specifications = undefined;

    isStoresInitialized = false;

    /*
    @observable
    partnerStore!: PartnerStore;

    @observable
    legacyRoutesStore!: LegacyRoutesStore;

    @observable
    homePageStore!: HomePageStore;

    @observable
    authStore!: AuthStore;
    */


    constructor() {
        this.init();
    }

    async init(): void {
        this.initApiClient();

        this.modulesStore = {};
        this.initAuthStore();
    }


    initApiClient() {
        const {
                  REACT_APP_API_BASE_URL,
                  REACT_APP_API_CLIENT_ID,
                  REACT_APP_API_CLIENT_SECRET,
              } = process.env;

        if (!REACT_APP_API_BASE_URL) {
            throw new Error('Missing API baseURL');
        }

        /*
        if (!REACT_APP_API_CLIENT_ID) {
          throw new Error('Missing API clientId');
        }

        if (!REACT_APP_API_CLIENT_SECRET) {
          throw new Error('Missing API clientSecret');
        }
        */


        this.apiClient = new WebApi({
            baseURL: REACT_APP_API_BASE_URL?.replace('/v1', ''),
            clientId: REACT_APP_API_CLIENT_ID,
            clientSecret: REACT_APP_API_CLIENT_SECRET,
        });
    }

    async initAuthStore() {
        this.modulesStore.authStore = new AuthStore(this);
        await this.modulesStore.authStore.checkAuth();
        runInAction( () => {
            this.modulesStore.isAuthStoreInitialized = true;
        })

    }

    async userAuthorized() {
        const specifications = await this.apiClient.fetchSpecifications();
        runInAction(() => {
            this.specifications = specifications;
            this.modulesStore.specificationsStore = new SpecificationsStore(this);
            this.modulesStore.usersStore = new UsersStore(this);
            this.modulesStore.limitsStore = new LimitsStore(this);
        });

        await this.modulesStore.usersStore.fetchUserInfo();

        runInAction(() => {
            this.modulesStore.webSocketStore = new WebSocketStore(this);
            this.modulesStore.mailerStore = new MailerStore(this);
            const initProjectStores = require(`../${process.env.REACT_APP_MODULES_DIR}/stores`).default;
            initProjectStores(this);
            this.modulesStore.isStoresInitialized = true;
        });
    }

    addStore(name, store) {
        runInAction(() => {
            this.modulesStore[name] = store;
        });
    }

    resetStores(): void {
        this.init();
    }
}

decorate(RootStore, {
    webSocketStore: observable,
    usersStore: observable,
    limitsStore: observable,
    modulesStore: observable,
    specifications: observable,
    isStoresInitialized: observable,
    isAuthStoreInitialized: observable,
});

export const createStores = () => {
    const rootStore = new RootStore();
    return rootStore.modulesStore;
};


export const storesContext = React.createContext(createStores());

export const useStores = () => React.useContext(storesContext);

